import React, { useEffect, useState } from 'react';
import { useParams, useNavigate } from 'react-router-dom';

// --- Video Gallery Data ---
const videoData = [
  { id: 'v1', title: 'MHADA Shirdhon Site Tour', embedUrl: 'https://www.youtube.com/embed/m2aPqZMtktw' }
  // { id: 'v2', title: '1BHK Sample Flat Walkthrough', embedUrl: 'https://www.youtube.com/embed/m2aPqZMtktw' },
  // { id: 'v3', title: 'Khoni Location & Connectivity', embedUrl: 'https://www.youtube.com/embed/kJQP7kiw5Fk' }
];

// --- Interactive Unit Types Data ---
const unitData = [
  { id: '1bhk', name: '1BHK', carpet: '321.84 Sq.ft', price: '₹15.44 L', status: 'Available' },
  { id: '2bhk', name: '2BHK', carpet: '550.00 Sq.ft', price: '₹35.50 L', status: 'Available' }
];

// --- Gallery Images (hero slider) ---
const galleryImages = [
  'https://lh3.googleusercontent.com/gps-cs-s/APNQkAEI0P8DHA0Ynd7qVkxFS0B4SIJLehMbCc7nido9MBYmtsLAWNvgseSDmKvFO7Ama8qKfbZ8_lSENvH_RZXyqdgmn3wqKuB89CMEin3gOcLFh7VdfudgR37YP-dcrytAc9AxEBxO=s1360-w1360-h1020-rw',
  'https://lh3.googleusercontent.com/gps-cs-s/APNQkAEI0P8DHA0Ynd7qVkxFS0B4SIJLehMbCc7nido9MBYmtsLAWNvgseSDmKvFO7Ama8qKfbZ8_lSENvH_RZXyqdgmn3wqKuB89CMEin3gOcLFh7VdfudgR37YP-dcrytAc9AxEBxO=s1360-w1360-h1020-rw',
  'https://lh3.googleusercontent.com/gps-cs-s/APNQkAHg9frlA985jpphzH6J7oDE7LKBYwmYKaR3jiIqLcTfKpKtHCRIi1JqU0hYZhPNNFeo-vRDc7fyEcpDK7L1IEo1VYwwoRCn70fJ-BWqyksOsiY35fXxMIe3MZESk61aVOYUcPkz=s1360-w1360-h1020-rw'
];

const SLIDE_INTERVAL = 4000;

// --- Accordion Data & Icons (Specifications) ---
const FloorIcon = () => (
  <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"><rect x="3" y="3" width="7" height="7"></rect><rect x="14" y="3" width="7" height="7"></rect><rect x="14" y="14" width="7" height="7"></rect><rect x="3" y="14" width="7" height="7"></rect></svg>
);
const FittingIcon = () => (
  <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"><path d="M14.7 6.3a1 1 0 0 0 0 1.4l1.6 1.6a1 1 0 0 0 1.4 0l3.77-3.77a6 6 0 0 1-7.94 7.94l-6.91 6.91a2.12 2.12 0 0 1-3-3l6.91-6.91a6 6 0 0 1 7.94-7.94l-3.76 3.76z"></path></svg>
);
const WallIcon = () => (
  <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"><rect x="3" y="3" width="18" height="18" rx="2" ry="2"></rect><line x1="3" y1="12" x2="21" y2="12"></line><line x1="12" y1="12" x2="12" y2="21"></line></svg>
);
const ChevronUp = () => (
  <svg xmlns="http://www.w3.org/2000/svg" width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"><path d="m18 15-6-6-6 6"></path></svg>
);
const ChevronDown = () => (
  <svg xmlns="http://www.w3.org/2000/svg" width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"><path d="m6 9 6 6 6-6"></path></svg>
);

const handleQuickEnquiry = (e) => {
    e.preventDefault(); // Prevents the page from reloading

    // Get the values from the form inputs
    const name = e.target['sidebar-name'].value;
    const phone = e.target['sidebar-phone'].value;
    const email = e.target['sidebar-email'].value;

    const whatsappNumber = '919702850777'; // Your WhatsApp number with country code

    // Format the message with line breaks (%0A) and bold text (*)
    const message = `*New Quick Enquiry!*%0A%0A*Property:* MHADA Shirdhon & Khoni%0A*Name:* ${name}%0A*Phone:* ${phone}%0A*Email:* ${email}%0A%0APlease share more details.`;

    // Open WhatsApp in a new tab
    window.open(`https://wa.me/${whatsappNumber}?text=${message}`, '_blank');
  };

const projectSpecifications = [
  {
    category: "Floor & Counter",
    icon: <FloorIcon />,
    details: [
      { label: "Living/Dining", value: "Vitrified Tiles" },
      { label: "Master Bedroom", value: "Vitrified Flooring" },
      { label: "Other Bedroom", value: "Vitrified Tiles Flooring" },
      { label: "Kitchen", value: "Vitrified Tiles" },
      { label: "Toilet", value: "Vitrified Tiles" },
      { label: "Balcony", value: "Vitrified Tiles" },
    ]
  },
  {
    category: "Fitting",
    icon: <FittingIcon />,
    details: [
      { label: "Toilets", value: "Branded CP Fittings & Sanitary Ware" },
      { label: "Kitchen", value: "Granite Platform with SS Sink" },
    ]
  },
  {
    category: "Wall & Ceiling",
    icon: <WallIcon />,
    details: [
      { label: "Interior", value: "Gypsum Finish" },
      { label: "Kitchen", value: "Glazed Tiles Dado" },
      { label: "Toilets", value: "Ceramic Tiles Dado" },
    ]
  }
];

// Navigation sections in order of appearance
const NAV_SECTIONS = ['videos', 'overview', 'pricing', 'specifications', 'amenities', 'about', 'floor-plans', 'location-plan', 'layout', 'ground-floor', 'typical-floor'];

export default function PropertyDetails() {
  const { id } = useParams();
  const navigate = useNavigate();
  const [activeTab, setActiveTab] = useState('videos');
  const [openSpec, setOpenSpec] = useState('Floor & Counter');
  
  // Interactive state initialized to the first flat type (1BHK)
  const [selectedUnit, setSelectedUnit] = useState(unitData[0]);

  // Hero image slider state
  const [activeImage, setActiveImage] = useState(0);

  // Share button feedback state
  const [linkCopied, setLinkCopied] = useState(false);

  // Always scroll to top when opening a new property
  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  // Auto-slide the hero gallery every 4 seconds
  useEffect(() => {
    const timer = setInterval(() => {
      setActiveImage((prev) => (prev + 1) % galleryImages.length);
    }, SLIDE_INTERVAL);
    return () => clearInterval(timer);
  }, [activeImage]);

  // --- Scroll Spy logic to update tabs dynamically on scroll ---
  useEffect(() => {
    const handleScroll = () => {
      // Find which section is currently taking up most of the view
      let currentSection = NAV_SECTIONS[0];
      
      for (const section of NAV_SECTIONS) {
        const element = document.getElementById(section);
        if (element) {
          const rect = element.getBoundingClientRect();
          // 160 is roughly the offset of our sticky header + breathing room
          if (rect.top <= 160) {
            currentSection = section;
          }
        }
      }
      
      // Prevent state updates if it hasn't changed to avoid unnecessary re-renders
      setActiveTab((prevTab) => prevTab !== currentSection ? currentSection : prevTab);
    };

    window.addEventListener('scroll', handleScroll);
    // Call once to set initial state
    handleScroll();

    return () => window.removeEventListener('scroll', handleScroll);
  }, []);

  const scrollToSection = (sectionId) => {
    setActiveTab(sectionId);
    const element = document.getElementById(sectionId);
    if (element) {
      const y = element.getBoundingClientRect().top + window.scrollY - 140;
      window.scrollTo({ top: y, behavior: 'smooth' });
    }
  };

  const handleContactMhada = () => {
    const whatsappNumber = '919702850777';
    const message = `Hello Sai Enforcement And Security Pvt. Ltd.!%0A%0A & Khoni* (${selectedUnit.name} · ${selectedUnit.price}).%0A%0APlease share more details.`;
    window.open(`https://wa.me/${whatsappNumber}?text=${message}`, '_blank');
  };

  const handleBrochureRequest = () => {
    const whatsappNumber = '919702850777';
    const message = `Hello Sai Enforcement And Security Pvt. Ltd.!%0A%0AI'd like to receive the *brochure* for *MHADA Shirdhon & Khoni* (${selectedUnit.name} · ${selectedUnit.price}).`;
    window.open(`https://wa.me/${whatsappNumber}?text=${message}`, '_blank');
  };

  const handleShare = async () => {
    const shareData = {
      title: 'MHADA Shirdhon & Khoni',
      text: 'Check out this MHADA project — MHADA Shirdhon & Khoni in Kalyan.',
      url: window.location.href,
    };

    try {
      if (navigator.share) {
        await navigator.share(shareData);
      } else if (navigator.clipboard) {
        await navigator.clipboard.writeText(shareData.url);
        setLinkCopied(true);
        setTimeout(() => setLinkCopied(false), 2000);
      }
    } catch (err) {
      // User cancelled the share dialog or it failed — no action needed
    }
  };

  return (
    <div className="detail-page pb-20 md:pb-0 bg-stone-50">
      
      {/* --- DESKTOP HERO SECTION --- */}
      <div className="hidden md:block relative">
        <div className="relative h-[520px] lg:h-[580px] overflow-hidden bg-stone-900">
          {galleryImages.map((img, idx) => (
            <img
              key={img}
              alt="MHADA Shirdhon & Khoni project"
              className={`absolute inset-0 w-full h-full object-cover detail-hero-ken-burns transition-opacity duration-700 ease-in-out ${
                idx === activeImage ? 'opacity-100' : 'opacity-0'
              }`}
              src={img}
            />
          ))}
          <div className="absolute inset-0 bg-gradient-to-t from-stone-950/90 via-stone-950/30 to-stone-950/20"></div>
          <div className="absolute inset-0 detail-hero-grid opacity-30"></div>
          
          <button onClick={() => navigate(-1)} className="absolute top-6 left-6 z-20 flex items-center gap-2 px-4 py-2 rounded-full bg-white/10 backdrop-blur-md border border-white/20 text-white hover:bg-white/20 transition shadow-lg">
            <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"><path d="m15 18-6-6 6-6"/></svg>
            Back
          </button>

          <div className="absolute right-6 top-1/2 -translate-y-1/2 flex flex-col gap-2 z-10">
            {galleryImages.map((img, idx) => (
              <button
                key={img}
                type="button"
                onClick={() => setActiveImage(idx)}
                aria-label={`View image ${idx + 1}`}
                className={`relative w-20 h-14 rounded-lg overflow-hidden border-2 transition-all duration-300 ${
                  idx === activeImage
                    ? 'border-amber-400 scale-105 shadow-lg shadow-amber-500/30'
                    : 'border-white/30 opacity-70 hover:opacity-100 hover:border-white/60'
                }`}
              >
                <img alt="" className="w-full h-full object-cover" src={img} />
              </button>
            ))}
          </div>

          <div className="absolute top-6 left-32 right-6 flex justify-between items-start z-10">
            <div className="flex flex-wrap gap-2">
              <span className="inline-flex items-center gap-1.5 px-3 py-1.5 rounded-full bg-emerald-500/90 backdrop-blur-md text-white text-xs font-semibold shadow-lg">
                <svg xmlns="http://www.w3.org/2000/svg" width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"><path d="M11.017 2.814a1 1 0 0 1 1.966 0l1.051 5.558a2 2 0 0 0 1.594 1.594l5.558 1.051a1 1 0 0 1 0 1.966l-5.558 1.051a2 2 0 0 0-1.594 1.594l-1.051 5.558a1 1 0 0 1-1.966 0l-1.051-5.558a2 2 0 0 0-1.594-1.594l-5.558-1.051a1 1 0 0 1 0-1.966l5.558-1.051a2 2 0 0 0 1.594-1.594z"></path><path d="M20 2v4"></path><path d="M22 4h-4"></path><circle cx="4" cy="20" r="2"></circle></svg>
                No Brokerage
              </span>
              <span className="inline-flex items-center gap-1.5 px-3 py-1.5 rounded-full bg-blue-600/90 backdrop-blur-md text-white text-xs font-semibold shadow-lg">
                <svg xmlns="http://www.w3.org/2000/svg" width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"><path d="M21.801 10A10 10 0 1 1 17 3.335"></path><path d="m9 11 3 3L22 4"></path></svg>
                RERA Verified
              </span>
            </div>
            <div className="relative flex gap-2 mr-24">
              <button type="button" onClick={handleShare} className="p-2.5 rounded-full bg-white/10 backdrop-blur-md border border-white/20 text-white hover:bg-white/20 transition" aria-label="Share">
                <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"><circle cx="18" cy="5" r="3"></circle><circle cx="6" cy="12" r="3"></circle><circle cx="18" cy="19" r="3"></circle><line x1="8.59" x2="15.42" y1="13.51" y2="17.49"></line><line x1="15.41" x2="8.59" y1="6.51" y2="10.49"></line></svg>
              </button>
              {linkCopied && (
                <span className="absolute top-full right-0 mt-2 px-3 py-1.5 rounded-lg bg-white text-stone-900 text-xs font-semibold shadow-lg whitespace-nowrap">
                  Link copied!
                </span>
              )}
            </div>
          </div>

          <div className="absolute bottom-0 left-0 right-0 p-8 lg:p-10 z-10">
            <div className="max-w-4xl">
              <p className="text-amber-400/90 text-sm font-medium uppercase tracking-widest mb-2">Residential · Ready to Move</p>
              <h1 className="text-3xl lg:text-5xl font-bold text-white tracking-tight leading-tight">MHADA Shirdhon & Khoni</h1>
              <p className="mt-3 text-stone-300 text-sm lg:text-base flex items-center gap-2 font-medium">
                <span className="px-2.5 py-1 rounded bg-amber-500/20 text-amber-400 text-xs border border-amber-500/30">{selectedUnit.name} Apartment</span>
                <span>• Kalyan, Maharashtra</span>
              </p>
            </div>
          </div>
        </div>

        {/* Floating Price Card */}
        <div className="relative -mt-6 mx-6 lg:mx-10 z-20">
          <div className="bg-white/90 backdrop-blur-xl border border-stone-200 rounded-2xl p-6 flex flex-wrap items-center justify-between gap-4 shadow-2xl">
            <div>
              <p className="text-xs text-stone-500 uppercase tracking-wider font-medium">Starting from ({selectedUnit.name})</p>
              <p className="text-3xl lg:text-4xl font-bold text-stone-900 tracking-tight">{selectedUnit.price}</p>
              <p className="text-sm text-stone-500 mt-1">All inclusive · Yes</p>
            </div>
            <button type="button" onClick={handleContactMhada} className="inline-flex items-center gap-2 px-8 py-3.5 rounded-xl text-white font-semibold text-sm shadow-lg bg-black hover:bg-stone-800 transition-all">
              Contact Mhada
            </button>
          </div>
        </div>
      </div>

      {/* --- MOBILE HERO SECTION --- */}
      <div className="block md:hidden">
        <div className="relative h-72 w-full overflow-hidden flex">
          {galleryImages.map((img, idx) => (
            <img
              key={img}
              alt="Mobile Banner"
              className={`absolute inset-0 w-full h-full object-cover transition-opacity duration-700 ease-in-out ${
                idx === activeImage ? 'opacity-100' : 'opacity-0'
              }`}
              src={img}
            />
          ))}
          <div className="absolute inset-0 bg-gradient-to-t from-stone-950/80 via-transparent to-stone-950/20"></div>
          <button onClick={() => navigate(-1)} className="absolute top-4 left-4 z-20 flex items-center justify-center w-10 h-10 rounded-full bg-white/20 backdrop-blur-md text-white shadow-lg">
            <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"><path d="m15 18-6-6 6-6"/></svg>
          </button>

          {/* Mobile dot indicators */}
          <div className="absolute bottom-4 left-1/2 -translate-x-1/2 z-20 flex gap-2">
            {galleryImages.map((img, idx) => (
              <button
                key={img}
                type="button"
                onClick={() => setActiveImage(idx)}
                aria-label={`View image ${idx + 1}`}
                className={`h-2 rounded-full transition-all duration-300 ${
                  idx === activeImage ? 'w-6 bg-amber-400' : 'w-2 bg-white/50'
                }`}
              />
            ))}
          </div>
        </div>
        <div className="px-4 py-5 space-y-3 bg-white">
          <h1 className="text-2xl font-bold text-stone-900">MHADA Shirdhon & Khoni</h1>
          <p className="text-sm text-stone-500">Project ID: {id}</p>
          <div className="flex justify-between items-center pt-2">
            <div>
              <p className="text-xs text-stone-400 uppercase">Selected Plan Price</p>
              <p className="text-2xl font-bold text-stone-900">{selectedUnit.price}</p>
            </div>
            <span className="px-3 py-1 rounded-full bg-amber-100 text-amber-800 font-bold text-xs">{selectedUnit.name}</span>
          </div>
        </div>
      </div>

      {/* --- STATS BAR --- */}
      <div className="border-y border-stone-200/80 bg-white/80 backdrop-blur-sm mt-4 md:mt-10">
        <div className="max-w-7xl mx-auto px-4 lg:px-8">
          <div className="flex overflow-x-auto scrollbar-hide py-4 md:py-6 md:justify-center md:flex-wrap gap-6 md:gap-10">
            <div className="flex flex-col items-center text-center min-w-[120px]">
              <div className="w-10 h-10 rounded-xl bg-amber-500/10 flex items-center justify-center mb-2 text-amber-600">
                <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"><path d="M2 20v-8a2 2 0 0 1 2-2h16a2 2 0 0 1 2 2v8"></path><path d="M4 10V6a2 2 0 0 1 2-2h12a2 2 0 0 1 2 2v4"></path></svg>
              </div>
              <p className="text-base font-bold text-stone-900 leading-tight">{selectedUnit.name} Apartment</p>
              <p className="text-xs text-stone-500 mt-0.5 uppercase tracking-wide">Configuration</p>
            </div>
            <div className="hidden md:block w-px bg-stone-200 self-stretch"></div>
            <div className="flex flex-col items-center text-center min-w-[120px]">
              <div className="w-10 h-10 rounded-xl bg-amber-500/10 flex items-center justify-center mb-2 text-amber-600">
                <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"><rect x="3" y="4" width="18" height="18" rx="2" ry="2"></rect><line x1="16" y1="2" x2="16" y2="6"></line></svg>
              </div>
              <p className="text-base font-bold text-stone-900 leading-tight">Ready to Move</p>
              <p className="text-xs text-stone-500 mt-0.5 uppercase tracking-wide">Possession</p>
            </div>
            <div className="hidden md:block w-px bg-stone-200 self-stretch"></div>
            <div className="flex flex-col items-center text-center min-w-[120px]">
              <div className="w-10 h-10 rounded-xl bg-amber-500/10 flex items-center justify-center mb-2 text-amber-600">
                <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"><path d="M15 2H6a2 2 0 0 0-2 2v16a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2V7Z"></path></svg>
              </div>
              <p className="text-base font-bold text-stone-900 leading-tight">MHADA Approved</p>
              <p className="text-xs text-stone-500 mt-0.5 uppercase tracking-wide">RERA Status</p>
            </div>
            <div className="hidden md:block w-px bg-stone-200 self-stretch"></div>
            <div className="flex flex-col items-center text-center min-w-[120px]">
              <div className="w-10 h-10 rounded-xl bg-amber-500/10 flex items-center justify-center mb-2 text-amber-600">
                <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"><path d="M15 3h6v6"></path><path d="m21 3-7 7"></path></svg>
              </div>
              <p className="text-base font-bold text-stone-900 leading-tight">{selectedUnit.carpet}</p>
              <p className="text-xs text-stone-500 mt-0.5 uppercase tracking-wide">Carpet Area</p>
            </div>
          </div>
        </div>
      </div>

      {/* --- MAIN CONTENT & SIDEBAR --- */}
      <div className="max-w-7xl mx-auto px-4 lg:px-8 py-8 md:py-10">
        <div className="flex flex-col lg:flex-row gap-8 lg:gap-10">
          
          {/* LEFT COLUMN: Details */}
          <main className="flex-1 min-w-0">
            {/* Sticky Tab Navigation (Fully Mobile Friendly) */}
            <nav className="sticky top-[72px] z-30 -mx-4 px-4 lg:mx-0 lg:px-0 py-3 bg-stone-50/90 backdrop-blur-md border-b border-stone-200/60 mb-6">
              <div className="flex gap-2 overflow-x-auto scrollbar-hide flex-nowrap">
                {NAV_SECTIONS.map((tab) => (
                  <button 
                    key={tab}
                    onClick={() => scrollToSection(tab)}
                    type="button" 
                    className={`shrink-0 whitespace-nowrap px-4 py-2 rounded-full text-sm font-medium transition-all duration-300 capitalize ${
                      activeTab === tab ? 'bg-stone-900 text-white shadow-md' : 'bg-white text-stone-600 border border-stone-200 hover:border-amber-300 hover:text-stone-900'
                    }`}
                  >
                    {tab.replace('-', ' ')}
                  </button>
                ))}
              </div>
            </nav>

            <div className="space-y-6">

              {/* --- VIDEO GALLERY --- */}
              <section id="videos" className="bg-white rounded-2xl p-6 md:p-8 shadow-sm border border-stone-200 scroll-mt-24">
                <div className="flex items-center gap-3 mb-6">
                  <div className="w-1 h-6 bg-amber-500 rounded-full"></div>
                  <h3 className="text-xl font-bold text-stone-900">Project Videos</h3>
                </div>
                
                <div className="flex gap-4 overflow-x-auto scrollbar-hide pb-4 snap-x snap-mandatory">
                  {videoData.map((video) => (
                    <div 
                      key={video.id} 
                      className="min-w-[280px] md:min-w-[320px] w-[80vw] md:w-[320px] shrink-0 snap-start bg-white rounded-xl overflow-hidden border border-stone-200 shadow-sm transition-all hover:shadow-md hover:border-amber-300 flex flex-col"
                    >
                      <div className="relative w-full aspect-video bg-stone-100">
                        <iframe
                          className="w-full h-full absolute inset-0"
                          src={video.embedUrl}
                          title={video.title}
                          frameBorder="0"
                          allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
                          allowFullScreen
                          loading="lazy"
                        ></iframe>
                      </div>
                      <div className="p-4 bg-stone-50 border-t border-stone-100">
                        <h4 className="font-semibold text-stone-800 text-sm line-clamp-1">{video.title}</h4>
                      </div>
                    </div>
                  ))}
                </div>
              </section>

              {/* --- Detailed Project Overview --- */}
              <section id="overview" className="bg-white rounded-2xl p-6 md:p-8 shadow-sm border border-stone-200 scroll-mt-24">
                <div className="flex items-center gap-3 mb-5">
                  <div className="w-1 h-6 bg-amber-500 rounded-full"></div>
                  <h3 className="text-xl font-bold text-stone-900">Project Overview</h3>
                </div>
                
                <div className="border-t border-amber-500/20 pt-6">
                  <div className="grid grid-cols-1 sm:grid-cols-2 gap-y-6 gap-x-4">
                    <OverviewItem 
                      title="Ownership" 
                      value="Leasehold" 
                      icon={<svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"><path d="M19 21v-2a4 4 0 0 0-4-4H9a4 4 0 0 0-4 4v2"></path><circle cx="12" cy="7" r="4"></circle></svg>} 
                    />
                    <OverviewItem 
                      title="Possession date" 
                      value="September/2027" 
                      icon={<svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"><rect x="3" y="4" width="18" height="18" rx="2" ry="2"></rect><line x1="16" y1="2" x2="16" y2="6"></line><line x1="8" y1="2" x2="8" y2="6"></line><line x1="3" y1="10" x2="21" y2="10"></line></svg>} 
                    />
                    <OverviewItem 
                      title="Property status" 
                      value="New Project" 
                      icon={<svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"><path d="M12 2l3.09 6.26L22 9.27l-5 4.87 1.18 6.88L12 17.77l-6.18 3.25L7 14.14 2 9.27l6.91-1.01L12 2z"></path></svg>} 
                    />
                    <OverviewItem 
                      title="Elevator" 
                      value="Yes" 
                      icon={<svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"><path d="M8 9l4-4 4 4"/><path d="M16 15l-4 4-4-4"/><rect x="4" y="4" width="16" height="16" rx="2" ry="2"/></svg>} 
                    />
                    <OverviewItem 
                      title="Category" 
                      value="Residential" 
                      highlighted={true}
                      icon={<svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"><path d="M3 9l9-7 9 7v11a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2z"></path><polyline points="9 22 9 12 15 12 15 22"></polyline></svg>} 
                    />
                    <OverviewItem 
                      title="Type" 
                      value="Flat / Apartment" 
                      icon={<svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"><rect x="4" y="2" width="16" height="20" rx="2" ry="2"></rect><path d="M9 22v-4h6v4"></path><path d="M8 6h.01"></path><path d="M16 6h.01"></path><path d="M12 6h.01"></path><path d="M12 10h.01"></path><path d="M12 14h.01"></path><path d="M16 10h.01"></path><path d="M16 14h.01"></path><path d="M8 10h.01"></path><path d="M8 14h.01"></path></svg>} 
                    />
                    <OverviewItem 
                      title="Gated Society" 
                      value="Yes" 
                      icon={<svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"><rect x="2" y="20" width="20" height="2"></rect><rect x="4" y="10" width="4" height="10"></rect><rect x="10" y="10" width="4" height="10"></rect><rect x="16" y="10" width="4" height="10"></rect><polygon points="12 2 2 7 22 7"></polygon></svg>} 
                    />
                    <OverviewItem 
                      title="Negotiable" 
                      value="Yes" 
                      icon={<svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"><path d="m11 17 2 2a1 1 0 1 0 3-3"/><path d="m14 14 2.5 2.5a2.12 2.12 0 1 0 3-3L15 9l-3 3"/><path d="m9 9 2-2 3 3-2 2"/><path d="m5 15-3-3 2-2 3 3"/><path d="m15 11-1-1"/></svg>} 
                    />
                    <OverviewItem 
                      title="Loan Facility" 
                      value="Available" 
                      icon={<svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"><path d="M10 13a5 5 0 0 0 7.54.54l3-3a5 5 0 0 0-7.07-7.07l-1.72 1.71"></path><path d="M14 11a5 5 0 0 0-7.54-.54l-3 3a5 5 0 0 0 7.07 7.07l1.71-1.71"></path></svg>} 
                    />
                    <OverviewItem 
                      title="Documents" 
                      value="Yes" 
                      icon={<svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"><path d="M22 19a2 2 0 0 1-2 2H4a2 2 0 0 1-2-2V5a2 2 0 0 1 2-2h5l2 3h9a2 2 0 0 1 2 2z"></path></svg>} 
                    />
                    <OverviewItem 
                      title="Maintenance" 
                      value="₹9999" 
                      icon={<svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"><path d="M21 12V7H5a2 2 0 0 1 0-4h14v4"></path><path d="M3 5v14a2 2 0 0 0 2 2h16v-5"></path><path d="M18 12a2 2 0 0 0 0 4h4v-4Z"></path></svg>} 
                    />
                    <OverviewItem 
                      title="Dedicated Parking" 
                      value="Yes" 
                      icon={<svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"><path d="M14 16H9m10 0h3v-3.15a1 1 0 0 0-.84-.99L16 11l-2.7-3.6a2 2 0 0 0-1.6-.8H9.3a2 2 0 0 0-1.6.8L5 11l-5.16.86a1 1 0 0 0-.84.99V16h3m10 0a2 2 0 1 1-4 0m4 0a2 2 0 1 0-4 0m-6 0a2 2 0 1 1-4 0m4 0a2 2 0 1 0-4 0"></path></svg>} 
                    />
                    <OverviewItem 
                      title="Open Parking" 
                      value="Yes" 
                      icon={<svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"><path d="M19 13v3"></path></svg>} 
                    />
                    <OverviewItem 
                      title="Commercial Space" 
                      value="20000 Sq.Ft" 
                      icon={<svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"><path d="M21.17 3.22a2 2 0 0 0-2.83 0L3.22 18.34a2 2 0 1 0 2.83 2.83l15.12-15.12a2 2 0 0 0 0-2.83Z" /><path d="m15.5 10 2.5-2.5" /><path d="m12 13.5 2.5-2.5" /><path d="m8.5 17 2.5-2.5" /></svg>} 
                    />
                  </div>
                </div>
              </section>

              {/* --- INTERACTIVE PRICE RANGE SECTION --- */}
              <section id="pricing" className="bg-white rounded-2xl p-6 md:p-8 shadow-sm border border-stone-200 scroll-mt-24">
                <h3 className="text-xl font-bold text-stone-900 mb-6">Price Range</h3>
                <div className="flex gap-4 flex-wrap">
                  {unitData.map((unit) => {
                    const isSelected = selectedUnit.id === unit.id;
                    return (
                      <button
                        key={unit.id}
                        type="button"
                        onClick={() => setSelectedUnit(unit)}
                        className={`p-5 border-2 rounded-xl transition-all text-left min-w-[240px] flex-1 sm:flex-initial outline-none ${
                          isSelected 
                            ? 'border-amber-500 bg-amber-50/30 ring-1 ring-amber-500 shadow-md' 
                            : 'border-stone-200 hover:border-stone-300 hover:bg-stone-50/50'
                        }`}
                      >
                        <h4 className="text-base font-bold text-stone-800 mb-3">{unit.name}</h4>
                        <p className="text-[11px] text-stone-400 uppercase tracking-wide mb-1">Carpet Area</p>
                        <p className="text-sm text-stone-600 mb-3">{unit.carpet}</p>
                        <p className="text-lg font-bold text-amber-600">{unit.price}</p>
                      </button>
                    );
                  })}
                </div>
              </section>

              {/* Project Specifications */}
              <section id="specifications" className="bg-white rounded-2xl p-6 md:p-8 shadow-sm border border-stone-200 scroll-mt-24">
                <div className="flex items-center gap-3 mb-5">
                  <div className="w-1 h-6 bg-amber-500 rounded-full"></div>
                  <h3 className="text-xl font-bold text-stone-900">Project Specifications</h3>
                </div>
                
                <div className="border-t border-amber-500/20 pt-2">
                  {projectSpecifications.map((spec) => (
                    <div key={spec.category} className="border-b border-stone-100 last:border-0">
                      <button
                        type="button"
                        onClick={() => setOpenSpec(openSpec === spec.category ? null : spec.category)}
                        className="w-full flex items-center justify-between py-4 text-left transition-colors hover:bg-stone-50/50"
                      >
                        <div className="flex items-center gap-3">
                          <span className="text-amber-500">{spec.icon}</span>
                          <span className="font-medium text-stone-900">{spec.category}</span>
                        </div>
                        <span className="text-stone-400">
                          {openSpec === spec.category ? <ChevronUp /> : <ChevronDown />}
                        </span>
                      </button>
                      
                      {openSpec === spec.category && (
                        <div className="pb-5 pt-1 px-2 md:px-4 space-y-3.5 animate-fadeIn">
                          {spec.details.map((detail, idx) => (
                            <div key={idx} className="flex flex-col sm:flex-row justify-between sm:items-center text-sm gap-1">
                              <span className="text-stone-500">{detail.label}</span>
                              <span className="text-stone-900 font-medium sm:text-right">{detail.value}</span>
                            </div>
                          ))}
                        </div>
                      )}
                    </div>
                  ))}
                </div>
              </section>

              {/* Amenities Section */}
              <section id="amenities" className="bg-white rounded-2xl p-6 shadow-sm border border-stone-200 scroll-mt-24">
                <h3 className="text-xl font-bold text-stone-900 mb-6">Amenities & Features</h3>
                <div className="grid grid-cols-3 sm:grid-cols-4 md:grid-cols-6 lg:grid-cols-8 gap-4">
                  <AmenityItem img="https://api.awasindia.com/Images/Amen/1736843992719.jpg" label="Borewell" />
                  <AmenityItem img="https://api.awasindia.com/Images/Amen/1736848166765.png" label="Road Facing" />
                  <AmenityItem img="https://api.awasindia.com/Images/Amen/1736847793912.png" label="CCTV" />
                  <AmenityItem img="https://api.awasindia.com/Images/Amen/1736847914109.jpg" label="Fire Alarm" />
                  <AmenityItem img="https://api.awasindia.com/Images/Amen/1736847984705.jpg" label="Gated Entry" />
                  <AmenityItem img="https://api.awasindia.com/Images/Amen/1736787135550.jpg" label="Parking" />
                  <AmenityItem img="https://api.awasindia.com/Images/Amen/1736787155862.png" label="Gym" />
                  <AmenityItem img="https://api.awasindia.com/Images/Amen/1736787176781.png" label="Pool" />
                </div>
              </section>

              {/* About Section */}
              <section id="about" className="bg-white rounded-2xl p-6 shadow-sm border border-stone-200 scroll-mt-24">
                <h3 className="text-xl font-bold text-stone-900 mb-4">About This Property</h3>
                <p className="text-sm text-stone-600 leading-relaxed">
                  Premium government-approved configuration variants managed by SES. Contact us for direct allocation information, payment breakdowns, and guided site walkthrough schedules.
                </p>
              </section>

              {/* --- FLOOR PLANS (Interactive) --- */}
              <section id="floor-plans" className="bg-white rounded-2xl p-6 shadow-sm border border-stone-200 scroll-mt-24">
                <h3 className="text-xl font-bold text-stone-900 mb-6">Floor Plans ({selectedUnit.name})</h3>
                <div className="border border-stone-200 rounded-xl p-5 max-w-sm bg-stone-50/50">
                  <p className="text-lg font-bold text-stone-900">{selectedUnit.carpet}</p>
                  <p className="text-xs text-stone-500 mb-3">Carpet Area Layout</p>
                  <img alt={`${selectedUnit.name} Layout`} className="rounded-lg border border-stone-100 max-h-[140px] object-cover w-full mb-3" src="https://lh3.googleusercontent.com/gps-cs-s/APNQkAEI0P8DHA0Ynd7qVkxFS0B4SIJLehMbCc7nido9MBYmtsLAWNvgseSDmKvFO7Ama8qKfbZ8_lSENvH_RZXyqdgmn3wqKuB89CMEin3gOcLFh7VdfudgR37YP-dcrytAc9AxEBxO=s1360-w1360-h1020-rw" />
                  <p className="text-base font-bold text-amber-600 mb-4">{selectedUnit.price}</p>
                  <button type="button" onClick={handleBrochureRequest} className="w-full flex items-center justify-center gap-2 text-sm font-semibold text-white bg-stone-900 hover:bg-stone-800 px-4 py-2.5 rounded-lg transition">
                    <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"><path d="M12 17V3"></path><path d="m6 11 6 6 6-6"></path><path d="M19 21H5"></path></svg> 
                     Brochure
                  </button>
                </div>
              </section>

              {/* --- LOCATION PLAN --- */}
              <section id="location-plan" className="bg-white rounded-2xl p-6 shadow-sm border border-stone-200 scroll-mt-24">
                <div className="flex items-center gap-2 mb-2">
                  <span className="flex items-center justify-center w-9 h-9 rounded-xl bg-amber-500/10 text-amber-600">
                    <svg xmlns="http://www.w3.org/2000/svg" width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"><path d="M20 10c0 4.993-5.539 10.193-7.399 11.799a1 1 0 0 1-1.202 0C9.539 20.193 4 14.993 4 10a8 8 0 0 1 16 0"></path><circle cx="12" cy="10" r="3"></circle></svg>
                  </span>
                  <h3 className="text-xl font-bold text-stone-900">Location Plan</h3>
                </div>
                <p className="text-sm text-stone-500 mb-5">Connectivity and surroundings of the MHADA Khoni project site.</p>

                <div className="overflow-hidden rounded-xl border border-stone-200 bg-stone-50">
                  <img
                    alt="MHADA Khoni Location Plan"
                    className="w-full h-auto object-contain"
                    loading="lazy"
                    src="https://www.mhada.gov.in/sites/default/files/inline-images/khoni-location_0.jpg"
                  />
                </div>
              </section>

              {/* --- LAYOUT --- */}
              <section id="layout" className="bg-white rounded-2xl p-6 shadow-sm border border-stone-200 scroll-mt-24">
                <div className="flex items-center gap-2 mb-2">
                  <span className="flex items-center justify-center w-9 h-9 rounded-xl bg-amber-500/10 text-amber-600">
                    <svg xmlns="http://www.w3.org/2000/svg" width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"><rect x="3" y="3" width="7" height="7"></rect><rect x="14" y="3" width="7" height="7"></rect><rect x="14" y="14" width="7" height="7"></rect><rect x="3" y="14" width="7" height="7"></rect></svg>
                  </span>
                  <h3 className="text-xl font-bold text-stone-900">Layout</h3>
                </div>
                <p className="text-sm text-stone-500 mb-5">Overall site layout and building arrangement of the MHADA Khoni project.</p>

                <div className="overflow-hidden rounded-xl border border-stone-200 bg-stone-50">
                  <img
                    alt="MHADA Khoni Layout"
                    className="w-full h-auto object-contain"
                    loading="lazy"
                    src="https://www.mhada.gov.in/sites/default/files/inline-images/khoni-layout_0.jpg"
                  />
                </div>
              </section>

              {/* --- GROUND FLOOR PLAN --- */}
              <section id="ground-floor" className="bg-white rounded-2xl p-6 shadow-sm border border-stone-200 scroll-mt-24">
                <div className="flex items-center gap-2 mb-2">
                  <span className="flex items-center justify-center w-9 h-9 rounded-xl bg-amber-500/10 text-amber-600">
                    <svg xmlns="http://www.w3.org/2000/svg" width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"><rect x="3" y="3" width="18" height="18" rx="2" ry="2"></rect><path d="M3 9h18"></path><path d="M9 21V9"></path></svg>
                  </span>
                  <h3 className="text-xl font-bold text-stone-900">Ground Floor Plan</h3>
                </div>
                <p className="text-sm text-stone-500 mb-5">Ground floor layout of the MHADA Khoni project building.</p>

                <div className="overflow-hidden rounded-xl border border-stone-200 bg-stone-50">
                  <img
                    alt="MHADA Khoni Ground Floor Plan"
                    className="w-full h-auto object-contain"
                    loading="lazy"
                    src="https://www.mhada.gov.in/sites/default/files/inline-images/ground-floor_2.jpg"
                  />
                </div>
              </section>

              {/* --- TYPICAL FLOOR PLAN --- */}
              <section id="typical-floor" className="bg-white rounded-2xl p-6 shadow-sm border border-stone-200 scroll-mt-24">
                <div className="flex items-center gap-2 mb-2">
                  <span className="flex items-center justify-center w-9 h-9 rounded-xl bg-amber-500/10 text-amber-600">
                    <svg xmlns="http://www.w3.org/2000/svg" width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"><rect x="3" y="3" width="18" height="18" rx="2" ry="2"></rect><path d="M3 9h18"></path><path d="M3 15h18"></path><path d="M9 3v18"></path></svg>
                  </span>
                  <h3 className="text-xl font-bold text-stone-900">Typical Floor Plan</h3>
                </div>
                <p className="text-sm text-stone-500 mb-5">Typical floor layout of the MHADA Khoni project building.</p>

                <div className="overflow-hidden rounded-xl border border-stone-200 bg-stone-50">
                  <img
                    alt="MHADA Khoni Typical Floor Plan"
                    className="w-full h-auto object-contain"
                    loading="lazy"
                    src="https://www.mhada.gov.in/sites/default/files/inline-images/typical-floor_2.jpg"
                  />
                </div>
              </section>

            </div>
          </main>

          {/* --- SIDEBAR FORM --- */}
          <aside className="hidden lg:block w-[360px] shrink-0">
            <div className="sticky top-24">
              <div className="bg-white rounded-2xl overflow-hidden shadow-xl border border-stone-200/80">
                <div className="bg-gradient-to-br from-stone-900 to-stone-800 p-5 text-white">
                  <p className="text-amber-400 text-xs font-semibold uppercase tracking-widest mb-1">Interested?</p>
                  <h2 className="text-lg font-bold leading-snug">MHADA Shirdhon & Khoni</h2>
                  <p className="text-stone-400 text-sm mt-1">Get in touch with the agency</p>
                </div>
                
                <div className="p-5 space-y-3 border-b border-stone-100">
                  <button type="button" onClick={handleContactMhada} className="w-full flex items-center justify-center gap-2 py-3 rounded-xl bg-black text-white font-semibold text-sm hover:bg-stone-800 transition">
                    <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"><path d="M13.832 16.568a1 1 0 0 0 1.213-.303l.355-.465A2 2 0 0 1 17 15h3a2 2 0 0 1 2 2v3a2 2 0 0 1-2 2A18 18 0 0 1 2 4a2 2 0 0 1 2-2h3a2 2 0 0 1 2 2v3a2 2 0 0 1-.8 1.6l-.468.351a1 1 0 0 0-.292 1.233 14 14 0 0 0 6.392 6.384"></path></svg>
                    Contact Mhada
                    </button>
                  <div className="grid grid-cols-2 gap-2">
                    <button type="button" className="flex items-center justify-center gap-1.5 py-2.5 rounded-xl border border-stone-200 text-stone-700 text-xs font-medium hover:bg-stone-50 transition">
                      <svg xmlns="http://www.w3.org/2000/svg" width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"><path d="M2.992 16.342a2 2 0 0 1 .094 1.167l-1.065 3.29a1 1 0 0 0 1.236 1.168l3.413-.998a2 2 0 0 1 1.099.092 10 10 0 1 0-4.777-4.719"></path></svg>
                      WhatsApp
                    </button>
                    <button type="button" className="flex items-center justify-center gap-1.5 py-2.5 rounded-xl border border-stone-200 text-stone-700 text-xs font-medium hover:bg-stone-50 transition">
                      <svg xmlns="http://www.w3.org/2000/svg" width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"><path d="M8 2v4"></path><path d="M16 2v4"></path><rect width="18" height="18" x="3" y="4" rx="2"></rect><path d="M3 10h18"></path><path d="m9 16 2 2 4-4"></path></svg>
                      Schedule
                    </button>
                  </div>
                </div>

                {/* ADDED onSubmit HANDLER HERE */}
                <form onSubmit={handleQuickEnquiry} className="p-5 space-y-4">
                  <p className="text-sm font-semibold text-stone-800">Quick enquiry</p>
                  <div>
                    <label htmlFor="sidebar-name" className="block text-xs font-medium text-stone-600 mb-1">Name <span className="text-red-500">*</span></label>
                    <input id="sidebar-name" required maxLength="50" placeholder="Your name" className="w-full px-3 py-2.5 rounded-lg border border-stone-200 text-sm focus:outline-none focus:ring-2 focus:ring-amber-500/40 focus:border-amber-400" type="text" />
                  </div>
                  <div>
                    <label htmlFor="sidebar-phone" className="block text-xs font-medium text-stone-600 mb-1">Phone <span className="text-red-500">*</span></label>
                    <input id="sidebar-phone" required pattern="[0-9]{10}" placeholder="10-digit number" className="w-full px-3 py-2.5 rounded-lg border border-stone-200 text-sm focus:outline-none focus:ring-2 focus:ring-amber-500/40 focus:border-amber-400" type="tel" />
                  </div>
                  <div>
                    <label htmlFor="sidebar-email" className="block text-xs font-medium text-stone-600 mb-1">Email <span className="text-red-500">*</span></label>
                    <input id="sidebar-email" required placeholder="you@email.com" className="w-full px-3 py-2.5 rounded-lg border border-stone-200 text-sm focus:outline-none focus:ring-2 focus:ring-amber-500/40 focus:border-amber-400" type="email" />
                  </div>
                  <button type="submit" className="w-full py-3 rounded-xl bg-stone-900 text-white font-semibold text-sm hover:bg-stone-800 transition">Send Enquiry</button>
                  <p className="flex items-center gap-1.5 text-xs text-stone-400 justify-center">
                    <svg xmlns="http://www.w3.org/2000/svg" width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"><path d="M20 13c0 5-3.5 7.5-7.66 8.95a1 1 0 0 1-.67-.01C7.5 20.5 4 18 4 13V6a1 1 0 0 1 1-1c2 0 4.5-1.2 6.24-2.72a1.17 1.17 0 0 1 1.52 0C14.51 3.81 17 5 19 5a1 1 0 0 1 1 1z"></path></svg>
                    Your details are secure with us
                  </p>
                </form>
              </div>
            </div>
          </aside>
        </div>
      </div>

      {/* --- MOBILE BOTTOM CTA --- */}
      <div className="fixed bottom-0 left-0 right-0 z-50 md:hidden bg-white/95 backdrop-blur-lg border-t border-stone-200 px-4 py-3 flex items-center justify-between gap-3 shadow-[0_-8px_30px_rgba(0,0,0,0.08)]">
        <div>
          <p className="text-xs text-stone-500">Starting from</p>
          <p className="text-lg font-bold text-stone-900">{selectedUnit.price}</p>
        </div>
        <button type="button" onClick={handleContactMhada} className="flex-1 max-w-[200px] flex items-center justify-center gap-2 py-3 rounded-xl bg-black text-white font-semibold text-sm">
          <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"><path d="M13.832 16.568a1 1 0 0 0 1.213-.303l.355-.465A2 2 0 0 1 17 15h3a2 2 0 0 1 2 2v3a2 2 0 0 1-2 2A18 18 0 0 1 2 4a2 2 0 0 1 2-2h3a2 2 0 0 1 2 2v3a2 2 0 0 1-.8 1.6l-.468.351a1 1 0 0 0-.292 1.233 14 14 0 0 0 6.392 6.384"></path></svg>
          Contact Mhada
          </button>
      </div>

    </div>
  );
}

// Helper Subcomponents
const OverviewItem = ({ title, value, icon, highlighted }) => (
  <div className={`flex items-center gap-4 ${highlighted ? 'bg-stone-50/80 p-3 rounded-2xl -m-3' : ''}`}>
    <div className="w-12 h-12 rounded-[14px] bg-amber-100 flex items-center justify-center text-amber-600 shrink-0">
      {icon}
    </div>
    <div>
      <p className="text-[11px] text-stone-400 uppercase tracking-widest font-medium mb-0.5">{title}</p>
      <p className="text-[15px] font-semibold text-stone-900 leading-tight">{value}</p>
    </div>
  </div>
);

const AmenityItem = ({ img, label }) => (
  <div className="flex flex-col items-center justify-center p-3 rounded-xl border border-stone-100 hover:border-amber-200 hover:shadow-sm transition bg-stone-50/50">
    <img alt={label} className="w-8 h-8 object-contain mb-2" src={img} />
    <p className="text-xs text-stone-600 font-medium text-center leading-tight">{label}</p>
  </div>
);